import Vue from 'vue';
import App from './App.vue';
import store from './store/index';
import ApiService from './services/api.service';
import router from './routes';
import isAuthenticated from './modules/auth.module';

import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';

import './plugins/bootstrap-vue';
import './plugins/highcharts';
import './plugins/vue-select';
import vuetify from './plugins/vuetify'

let debug = false;

let baseUrl = '';
let apiBaseUrl = '';

if (isAuthenticated) {
  let urlParams = new URLSearchParams(window.location.search);
  let jwtToken = urlParams.get('token');

  let tokenParts = jwtToken.split('.');
  let decodedData = JSON.parse(window.atob(tokenParts[1]));
  debug = decodedData.debug;  // O debug é coletado do backend

  baseUrl = debug ? "http://" + decodedData.domain + ":8000" : "https://" + decodedData.domain;

  // Set the base URL of the API
  apiBaseUrl = debug ? "http://" + decodedData.domain + ":8000/api/admin/" : "https://" + decodedData.domain + "/api/admin/";
  ApiService.init(apiBaseUrl);
} else {
  router.push('/Unauthorized');
}

if (!debug) {
  Sentry.init({
    dsn: 'https://b56c504a69d74d0fa1cdb572203d4b03@sentry.io/1534841',
    integrations: [new Integrations.Vue({Vue, attachProps: true})],
    release: 'shoppub-dashboard@1.0.1',
    environment: debug ? 'development' : 'production'
  });
}

Vue.config.productionTip = false;

new Vue({
  store,
  router: router,
  vuetify,
  render: h => h(App)
}).$mount('#app');
